import { render } from "./branchCPO.vue?vue&type=template&id=519c88b0"
import script from "./branchCPO.vue?vue&type=script&lang=js"
export * from "./branchCPO.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__